import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint, getDirection } from "../../../../../../../common-deprecated/themes/common";
import * as CashPrice from "../../common/price/styles/CashPrice";
import * as MonthlyPrice from "../../common/price/styles/MonthlyPrice";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import {
    h5Style,
    h6Style,
    captionStyle,
    bodyStyle,
    h3Style,
} from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { AvailabilityBadges } from "../../../../../../../common-deprecated/components/aem/lexus/availability-badges/styles/AvailabilityBadgesStyles";

export const GradeContainer = styled.div`
    margin-bottom: ${theme.space[5]}px;
    background: ${theme.colors.mist};

    @media ${getBreakpoint("only", "md")} {
        max-width: 595px;
        margin-left: auto;
        margin-right: auto;
    }
`;

export const GradeImageWrapper = styled.div`
    min-height: 100%;
    background: ${theme.colors.mist};
    background: linear-gradient(0deg, rgba(244, 246, 251, 1) 40%, rgba(255, 255, 255, 1) 40%);
    img {
        display: block;
        max-width: 80%;
        margin: 0 auto;
    }
    @media ${getBreakpoint("up", "lg")} {
        padding: ${theme.space[6]}px 0;
        background: ${theme.colors.mist};
        background: linear-gradient(270deg, rgba(244, 246, 251, 1) 62%, rgba(255, 255, 255, 1) 62%);
        [dir="rtl"] & {
            background: linear-gradient(270deg, rgba(255, 255, 255, 1) 38%, rgba(244, 246, 251, 1) 38%);
        }
        img {
            max-width: 100%;
        }
    }
`;

export const GradeInfoContainer = styled.div`
    position: relative;
    min-height: 100%;
    padding: ${theme.space[5]}px ${theme.space[3]}px;
    @media ${getBreakpoint("up", "md")} {
        padding: ${theme.space[5]}px;
    }
    @media ${getBreakpoint("up", "lg")} {
        padding: ${theme.space[6]}px ${theme.space[6]}px ${theme.space[6]}px 0;
    }
    /* custom media query because the design is off-grid */
    @media screen and (min-width: 1280px) {
        padding-${getDirection("right")}: 0;
        &::after {
            position: absolute;
            top: 0;
            ${getDirection("right")}: -60px;
            width: 60px;
            height: 100%;
            content: "";
            background: ${theme.colors.mist};
        }
    }

    ${AvailabilityBadges} {
        margin-top: ${theme.space[2]}px;
    }
`;

export const Title = styled.h2`
    margin-bottom: ${theme.space[1]}px;
    text-transform: none;
    color: ${theme.colors.black};
    ${h3Style};
`;

export const SubTitle = styled.h3`
    margin: 0;
    color: ${theme.colors.brushedSteel};
    ${h6Style};
`;

export const PriceWrapper = styled.div`
    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        color: ${theme.colors.black};
        ${h5Style};
    }
`;

export const LabelFrom = styled.div`
    text-transform: uppercase;
    color: ${theme.colors.brushedSteel};
    ${captionStyle};
`;

export const FeatureList = styled.ul`
    margin: 0 0 ${theme.space[5]}px;
    padding: 0;
    list-style: none;
    color: ${theme.colors.platinumDark};
    ${bodyStyle};

    li {
        position: relative;
        margin: 0 0 ${theme.space[1]}px;
        padding: 0;
        padding-${getDirection("left")}: 20px;
        ${bodyStyle};
        &::before {
            position: absolute;
            top: 11px;
            ${getDirection("left")}: 0;
            width: 4px;
            height: 4px;
            content: "";
            background: ${theme.colors.black};
            border-radius: 50%;
        }
    }
`;

export const Actions = styled.div`
    margin-top: ${theme.space[5]}px;

    ${Button.ButtonTertiary} {
        margin-top: ${theme.space[3]}px;
        /* dirty quickhack / fix because RTL styles are broken on the buttons */
        .btn-text > .btn-text {
            display: inline-block;
            padding-bottom: 0.7rem;
            line-height: 1.2;
            border-bottom: 0.2rem solid ${theme.colors.azure};
        }
        .btn-text::before {
            display: none !important;
        }
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;
    margin: 20px 0;
`;

export const CompareCTA = styled.button`
    width: 100%;
    background-color: transparent;
    border: none;
`;
